/* global axios */
import ApiClient from './ApiClient';

// Resumo da conversa pela IA, a pedido do atendente. O backend enfileira o job
// e responde 202; o resumo chega como NOTA PRIVADA na conversa (message.created
// por ActionCable), não nesta resposta.
class ConversationAiSummaryAPI extends ApiClient {
  constructor() {
    super('conversations', { accountScoped: true });
  }

  create({ conversationId, includePrevious }) {
    return axios.post(`${this.url}/${conversationId}/ai_summary`, {
      include_previous: includePrevious,
    });
  }
}

export default new ConversationAiSummaryAPI();
